import axios from 'ps-components/lib/apiClient';
import { useMutation } from 'react-query';

export const useDeleteReport = () => {
    const deleteReport = async (reportPk: number) => {
        const response = await axios.apiPost('/api/report-writer/report/deleteReport', { report_pk: reportPk })

        return response.data
    }

    const mutation = useMutation(deleteReport)
    return mutation
}